import { Model as BaseModel } from 'vue-api-query'
import env from '@/services/env'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc).extend(relativeTime)

export default class Model extends BaseModel {
  baseURL() {
    return env.apiUrl
  }

  request(config) {
    return this.$http.request(config)
  }

  get createdAtFromNow() {
    return dayjs.utc(this.created_at).fromNow()
  }
}
